import { GridRowId, GridValidRowModel, useGridApiRef } from '@mui/x-data-grid-pro';
import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { createContext, MutableRefObject, useContext } from 'react';

const getIsGroupRow = (row?: GridValidRowModel) => {
  if (!row) return false;
  return row?.path?.length === 1;
};

const getIsGroupSubRow = (row?: GridValidRowModel) => {
  if (!row) return false;
  return row?.path?.length === 2;
};

export const useIsGrouping = (apiRef?: ReturnType<typeof useGridApiRef>) => {
  const getIsGroupByRowId = (id: GridRowId) => {
    if (!apiRef?.current) {
      throw new Error('apiRef is not defined');
    }
    const row = apiRef.current.getRow<GridValidRowModel>(id);
    if (!row) return false;
    return getIsGroupRow(row);
  };

  const getIsGroupSubRowByRowId = (id: GridRowId) => {
    if (!apiRef?.current) {
      throw new Error('apiRef is not defined');
    }
    const row = apiRef.current.getRow<GridValidRowModel>(id);
    if (!row) return false;
    return getIsGroupSubRow(row);
  };

  return {
    getIsGroupRow,
    getIsGroupSubRow,
    getIsGroupByRowId,
    getIsGroupSubRowByRowId
  };
};

const IsGroupingContext = createContext<ReturnType<typeof useIsGrouping>>({
  getIsGroupRow,
  getIsGroupSubRow,
  getIsGroupByRowId: () => {
    return false;
  },
  getIsGroupSubRowByRowId: () => {
    return false;
  }
});

export const IsGroupingProvider = ({
  children,
  apiRef
}: {
  children: React.ReactNode;
  apiRef: MutableRefObject<GridApiPro>;
}) => {
  const isGrouping = useIsGrouping(apiRef);
  return <IsGroupingContext.Provider value={isGrouping}>{children}</IsGroupingContext.Provider>;
};

export const useIsGroupingContext = () => {
  return useContext(IsGroupingContext);
};
